import ShopTableItem from 'components/TableItem/ShopTableItem';
import React, { useEffect, useState } from 'react';
import MyPagination from '../../components/Common/MyPagination';
import * as shopApi from '../../apis/shopApi'


import {
    Table,
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
} from "reactstrap"

import { Link, useHistory, withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useQuery } from './../../Utils/UseQuery';
import { getMessage } from './../../Utils/ErrMessageUtils';
import MetaTags from 'react-meta-tags';


function ListShop(props) {

    const [data, setData] = useState([])
    const [additionalData, setAdditionalData] = useState({})
    let history = useHistory();
    useEffect(() => {
        let page = useQuery(props.location.search).get('page');
        fetchData(page);
    }, [props.location.search])
    const fetchData = page => {
        shopApi.getListShop(page, fetchDataSuccess, fetchDataFail)
    }
    const fetchDataSuccess = res => {
        setAdditionalData(res.data.data)
        setData(res.data.data.data);
    }
    const fetchDataFail = res => {
        alert(getMessage(res.message))
    }

    const showShops = () => {
        if (data.length === 0) {
            return (<tr></tr>);
        }
        return data.map((v, i) => {
            return (<ShopTableItem key={i} data={v} count={i + 1} />)
        })
    }
    const onChangePage = (page) => {
        let url = props.location.pathname + '?page=' + page;
        history.push(url);
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>Danh sách công ty</title>
            </MetaTags>
            <Card>
                <CardBody>
                    <CardTitle className="h4">Danh mục Cửa hàng</CardTitle>
                    <Row className="justify-content-between">
                        <Col xs="auto" sm="auto">
                        </Col>
                        <Col xs="auto" sm="auto">
                            <Link to="/shops/create">
                                <Button color='primary' className='px-3 rounded-pill'>
                                    <i className="fas fa-plus mr-2"></i> Thêm mới
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                    <div className="table-responsive">
                        <Table className="table mb-3">
                            <thead>
                                <tr>
                                    <th>Mã cửa hàng</th>
                                    <th>Tên cửa hàng</th>
                                    <th>Địa chỉ</th>
                                    <th>Số điện thoại</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {showShops()}
                            </tbody>
                        </Table>
                    </div>
                    <MyPagination 
                        startPage={additionalData.current_page ? additionalData.current_page : 1} 
                        totalItemsCount={additionalData.total ? additionalData.total : 5} 
                        itemsCountPerPage={additionalData.per_page ? additionalData.per_page : 10}
                        callback={onChangePage} />
                </CardBody>
            </Card>
        </div>
    )
}
ListShop.propTypes = {
    location: PropTypes.object,
}


export default withRouter(ListShop);
